export const WeekdayGuard = (to, from, next) => {
  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];

  if (days.indexOf(to.params.day) !== -1) {
    next();
    return;
  }

  const todaysDay = (new Date()).getDay() - 1; // Using zero index, though Sunday is -1 in this case
  if (todaysDay === 5 || todaysDay === -1) {
    next(`/dishes/${days[0]}`);
    return;
  }

  next(`/dishes/${days[todaysDay]}`);
};

export default {
  WeekdayGuard,
};
